var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"rating-stats"},_vm._l((_vm.stats),function(value,key){return _c('div',{key:key},[_c('span',{staticClass:"rating-count mr-2"},[_vm._v(_vm._s(value))]),_vm._v(" "),_c('rating',{staticClass:"rating-lg",attrs:{"rate":Number.parseInt(key)}})],1)}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cac94000","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/RatingStats.vue
// module id = yLAr
// module chunks = 1